import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import image1 from "../../../../../../shared/resources/batmanlogo.jpg";
import "./styles.scss";
import { useWorkshops } from "../../../../../../contexts/workshops-context/WorkshopsContext";
import { useAppUser } from "../../../../../../contexts/user-context/UserContext";
import PageHeader from "../../../../components/page-header/PageHeader";
import CourseComponent from "../../../library/components/CourseComponent";
import SelectCountry from "../../../../../../shared/components/countrySelectorModal/SelectCountry";

const ArchivedWorkshops = () => {
  const workshopsContext = useWorkshops();
  const appUser = useAppUser();

  const {
    country,
    archivedWorkshops: workshops,
    loading,
    mainLoading,
    setLoading,
    showModel,
    setShowModel,
  } = workshopsContext;

  return (
    <>
      <PageHeader title="Archived Workshops" />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
        }}
      >
        <Row>
          {country !== "DEFAULT" && workshops.length === 0 && !mainLoading && (
            <Col
              className="text-center"
              style={{
                marginTop: "100px",
                color: "grey",
              }}
            >
              <h4>There are no workshops archived for this country yet..</h4>
            </Col>
          )}
          <Col xs={12} />
          {workshops.map((wk, index) => {
            return (
              <Col
                xs={12}
                sm={12}
                md={6}
                lg={4}
                className="py-2 pl-0 pr-0"
                key={index}
              >
                <CourseComponent
                  index={index}
                  id={wk.id}
                  title={wk.title}
                  description={wk.description}
                  isArchived
                  imageURL={image1}
                  loading={loading}
                  onActionFinished={() => setLoading(false)}
                  onActionStart={() => setLoading(true)}
                  orderNo={wk.orderNo}
                  thumbnail={wk.thumbnail}
                />
              </Col>
            );
          })}
        </Row>
        {appUser.userRole.isAdmin && (
          <Row>
            <SelectCountry
              show={showModel}
              onHide={() => {
                setShowModel(false);
              }}
            />
          </Row>
        )}
      </Container>
    </>
  );
};

export default ArchivedWorkshops;
